import RegistrationTracker from '../RegistrationTracker';
import KarteTracker from '../../../lib/KarteTracker';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('personal-orders-completed-v2')) return;

  const tracker = new RegistrationTracker();
  tracker.track(8, { subset: null });

  const karteTracker = new KarteTracker();
  karteTracker.trackConversion('subscription_reg');
});
